import { SxProps, Theme, SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Default Styling
 */
const sxCoreIcon: SxProps = {
	width: "24px",
	height: "24px",
	maxWidth: "100%",
	maxHeight: "100%",

	boxSizing: "border-box",
};

const propsCoreIcon: SvgIconProps = {
	inheritViewBox: true,
};

/**
 * Define props and a handler for common use cases (sx)
 */
type SxOverrides = {
	dummySx?: boolean;
};

const SxOverrideHandler = (sxDefault: SxProps<Theme>, sxOverrides?: SxOverrides) => {
	if (!sxOverrides) {
		return sxDefault;
	}

	const sx = { ...sxDefault };

	return sx;
};

/**
 * Additional props for functions internal logic
 */
type InternalLogic = {
	dummyLogic?: boolean;
};

/**
 * Type for all the props in the main component
 */
export type CoreIconProps = SvgIconProps & SxOverrides & InternalLogic;

/**
 * Default styled container to display text content
 */
export const CoreIcon = (props: CoreIconProps) => {
	/* Apply overrides if existent */
	const { dummySx, children, sx, ...rest } = props;
	const sxDefault: SxProps<Theme> = SxOverrideHandler(sxCoreIcon, { dummySx });

	return (
		<SvgIcon sx={{ ...sxDefault, ...sx }} {...propsCoreIcon} {...rest}>
			{children}
		</SvgIcon>
	);
};
